import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import GamesGrid from './components/GamesGrid';
import Footer from './components/Footer';
import { LanguageProvider } from './components/Localization.js';
import { gamesData } from './data/games';

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-slate-50 font-sans text-gray-800">
        {/* Scroll progress indicator */}
        <motion.div
          style={{ scaleX }}
          className="fixed top-0 left-0 right-0 h-1 origin-left bg-gradient-to-r from-brand-400 to-emerald-500 z-[60]"
        />

        {/* Fixed navbar */}
        <Navbar games={gamesData} />

        {/* Main content */}
        <main>
          <Hero games={gamesData} />
          <Features />
          <GamesGrid games={gamesData} />
          <Footer />
        </main>
      </div>
    </LanguageProvider>
  );
}

export default App;
